import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { userLogin } from './authApi';
import LoadingSpinner from '../components/ui/loading-spinner';
import { useAppDispatch } from '../app/hooks';

//	--------------------------------------------------------------------------
//
//	R E D U X   S T A T E   M A N A G E M E N T
//
//	--------------------------------------------------------------------------

import { persistAppState } from '../app-actions';

export default function AuthCallback() {
  //
  //	--------------------------------------------------------------------------
  //
  //	R E D U X   S T A T E   H A N D L I N G
  //
  //	--------------------------------------------------------------------------

  const dispatch = useAppDispatch();

  //	--------------------------------------------------------------------------
  //
  //	D E C L A R A T I O N S
  //
  //	--------------------------------------------------------------------------

  const { search, pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(search);
      const code = params.get('code');
      const target = sessionStorage.getItem('postLoginRedirect') || '/home';

      if (!code) {
        navigate(target, { replace: true });
        return;
      }

      // do the login exchange
      const { ok, nextAppState } = await userLogin({
        authCode: code,
        redirectUri: `${window.location.origin}${pathname}`,
      });

      if (ok && nextAppState) {
        // go back to where user started (or home)
        dispatch(persistAppState(nextAppState));
        navigate(target, { replace: true });
        sessionStorage.removeItem('postLoginRedirect');
      } else {
        console.error('AuthCallback: Login failed');
        navigate('/home', { replace: true });
      }
    };

    void run();
  }, [search, navigate, pathname, dispatch]);

  return (
    <LoadingSpinner
      show={true}
      message="Please wait while we are signing you in and fetching your settings"
    />
  );
}
